import { render, staticRenderFns } from "./OrderUpdatePaymentSubtotal.vue?vue&type=template&id=47a985fc"
import script from "./OrderUpdatePaymentSubtotal.vue?vue&type=script&lang=js"
export * from "./OrderUpdatePaymentSubtotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports